<template>
  <div>
  <Card>
      <Row>
        <i-col span="24" :md="20">
          <Form ref="searchForm" inline :model="searchForm" :label-width="90" @submit.native.prevent>
            <FormItem label="名称/命名空间" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入名称/命名空间" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getDeploymentList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="4">
          <Button style="float: right;" @click="addDeployment" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getDeploymentList"></page>
        </div>
     </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="0" :rules="ruleValidate">
           <form-item label="" prop="deploymentYaml" >
            <i-input  v-model="formItem.deploymentYaml" placeholder="填入 YAML 文件内容，将指定资源部署到当前所选命名空间。" type="textarea" :autosize="{minRows: 20}"></i-input>
          </form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getDeploymentDetail, getDeploymentList, editDeploymentPodNum, deleteDeployment, saveDeployment, updateDeploymentYaml } from '@/api/cloud'
export default {
  name: 'DeploymentList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      podNum: 0,
      columns: [
        { title: '名称', key: 'name', align: 'center', sortable: 'custom', minWidth: 100 },
        { title: '命名空间', key: 'namespace', align: 'center', minWidth: 200 },
        { title: '标签', key: 'labels', align: 'center', minWidth: 80 },
        { title: '容器组', key: 'replicas', align: 'center', minWidth: 80 },
        { title: '创建时间', key: 'start_time', align: 'center', minWidth: 150 },
        { title: '镜像', key: 'image', align: 'center', minWidth: 120 },
        {
          title: '操作',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    title: '详情'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.viewDetail(params)
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    title: '伸缩'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editDeployment(params)
                    }
                  }
                }, '伸缩'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    title: '修改'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.updateDeployment(params)
                    }
                  }
                }, '修改'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteDeployment(params)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: '删除'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, '删除')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      updatedYaml: '',
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        deploymentYaml: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        deploymentYaml: [{ required: true, message: 'YAML 文件内容不能为空 !', trigger: 'blur' }]
      }
    }
  },
  methods: {
    viewDetail (params) {
      this.handleRenderDetail(params, true)
    },
    updateDeployment (params) {
      this.handleRenderDetail(params, false)
    },
    handleRenderDetail (params, flag) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace
      }
      getDeploymentDetail(data).then(res => {
        let data = res.data
        this.$Modal.confirm({
          width: '750px',
          title: 'Deployment详情',
          onOk: () => {
            if (!flag) {
              this.update(params, this.updatedYaml)
            }
          },
          render: (h) => {
            return h('div', [
              h('Input', {
                props: {
                  type: 'textarea',
                  value: data,
                  autofocus: true,
                  placeholder: '',
                  readonly: flag,
                  autosize: { minRows: 10, maxRows: 20 }
                },
                on: {
                  'on-blur': (event) => {
                    this.updatedYaml = event.target.value
                  }
                },
                style: {
                  width: '100%',
                  height: '100%'
                }
              })
            ])
          }
        })
      })
    },
    update (params, yaml) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace,
        yaml: yaml
      }
      updateDeploymentYaml(data).then(res => {
        if (res.status === 200) {
          this.$Message.success('更新成功')
          this.getDeploymentList()
        } else {
          this.$Message.error('更新失败')
        }
      })
    },
    getDeploymentList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        search: this.searchForm.name
      }
      getDeploymentList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    addDeployment () {
      this.change = true
    },
    editDeployment (params) {
      this.podNum = params.row.replicas
      this.$Modal.confirm({
        width: '350px',
        title: '伸缩 部署',
        onOk: () => {
          this.editDeploymentPodNum(params)
        },
        render: (h) => {
          return h('div', [
            h('span', {style: {color: '#515a6e'}}, '资源' + params.row.name + ' 将更新以反映所需数量'),
            h('Divider', {
            }),
            h('InputNumber', {
              props: {
                value: params.row.replicas,
                min: 0
              },
              style: {
                width: '100%',
                height: '100%'
              },
              on: {
                input: (val) => {
                  this.podNum = val
                }
              }
            })
          ])
        }
      })
    },
    deleteDeployment (params) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace
      }
      deleteDeployment(data).then(res => {
        if (res.status === 200) {
          this.$Message.success('删除Deployment(' + name + ')成功')
          this.getDeploymentList()
        } else {
          this.$Message.error('删除Deployment(' + name + ')失败')
        }
      })
    },
    editDeploymentPodNum (params) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace,
        num: this.podNum
      }
      editDeploymentPodNum(data).then(res => {
        if (res.status === 200) {
          this.$Message.success('更新成功')
          this.getDeploymentList()
        } else {
          this.$Message.error('更新失败')
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = null
      that.repository = null
      that.tag = null
      that.description = null
      that.dockerfile = null
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getDeploymentList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          // if (false) {
          // editDeployment(this.formItem).then(res => {
          //   if (res.data.id > 0) {
          //     this.change = false
          //     this.getDeploymentList()
          //   } else {
          //     // this.$Notice.error({title: res.data})
          //     this.$Message.error(res.data.msg)
          //   }
          // }).catch(res => {
          //   console.log(res.response)
          //   this.$Notice.error({
          //     title: '操作失败！ 错误状态码:' + res.request.status,
          //     desc: res.request.responseText
          //   })
          // })
          // } else {
          saveDeployment(this.formItem).then(res => {
            if (res.data.status === true) {
              this.change = false
              this.getDeploymentList()
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
          // }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.getDeploymentList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
